import Vue from 'vue'
import store from './vuex/index'
import VueResource from 'vue-resource'

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
  return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}

// GET接口
export function get(url, data, callback, errCallback) {
  callback = callback || function(response) {
    //console.log(response)
  }

  errCallback = errCallback || function(response) {
    // console.log(response)
  }

  Vue.http.get(process.env.API + url, {
      params: data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'token': store.state.common.token
      },
    }).then((response) => callback(response))
    .catch((response) => errCallback(response))
}

// POST接口
export function post(url, data, callback, errCallback) {
  callback = callback || function(response) {
    // console.log(response)
  }

  errCallback = errCallback || function(response) {
    // console.log(response)
  }

  Vue.http.post(process.env.API + url, data, {
      emulateJSON: true,
      headers: {
        'token': store.state.common.token
      },
    }).then((response) => callback(response))
    .catch((response) => errCallback(response))
}

// alert
export function rsAlert(title, content, hide, show) {
  Vue.$vux.alert.show({
    title: title,
    content: content,
    onShow() {
      show = show || function() {
        console.log('alert show')
      }
      show()
    },
    onHide() {
      hide = hide || function() {
        console.log('alert hide')
      }
      hide()
    }
  })
}

/**
 * confirm
 * @type {Date}
 */
export function rsConfirm(title, content, confirmText, cancelText, confirm, cancel) {
  Vue.$vux.confirm.show({
    'title': title,
    'content': content,
    'confirm-text': confirmText,
    'cancel-text': cancelText,
    onConfirm() {
      confirm = confirm || function() {
        console.log('confirm show')
      }
      confirm()
    },
    onCancel() {
      cancel = cancel || function() {
        console.log('confirm hide')
      }
      cancel()
    }
  })
}

/**
 * 配置节流函数
 * @param  {[Function]}  fn     [要执行的函数]
 * @param  {[Number]}  delay    [延迟执行的毫秒数]
 * @param  {[Number]}  mustRun  [至少多久执行一次]
 * @return {[Function]}         [节流函数]
 */
export function throttle(fn, wait, mustRun) {
  let timeout
  let startTime = new Date()
  return function() {
    let context = this
    let args = arguments
    let curTime = new Date()

    clearTimeout(timeout)
    // 如果达到了规定的触发时间间隔，触发 handler
    if (curTime - startTime >= mustRun) {
      fn.apply(context, args)
      startTime = curTime
      // 没达到触发间隔，重新设定定时器
    } else {
      timeout = setTimeout(fn, wait)
    }
  }
}

/**
 * 字符串过滤
 */
export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 * 验证规则
 * 账号验证规则: 包含数字和字母, 6-20位 (type:1)
 * 手机验证规则: 11位数字，以1开头(type:2)
 * 验证电话号码：区号+号码，区号以0开头，3位或4位 (type:3)
 * 验证邮箱 验证规则：例如xxxxx@xxx.com” (type:4)
 **/
export function validate(str, type) {
  let reg

  switch (type) {
    case 1:
      reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
      break
    case 2:
      reg = /^1[3|4|5|7|8|9][0-9]\d{4,8}$/
      break
    case 3:
      reg = /^((010|02\d{1}|0[3-9]\d{2})-)?\d{7,9}(-\d+)?$/
      break
    case 4:
      reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      break
  }

  return reg.test(str)
}


/**
 * 时间格式化
 */
export function timeToStr(timestamp, format) {
  let time = new Date(timestamp * 1000)
  let date = {
    "M+": time.getMonth() + 1, //月份
    "d+": time.getDate(), //日
    "h+": time.getHours(), //小时
    "m+": time.getMinutes(), //分
    "s+": time.getSeconds(), //秒
    "q+": Math.floor((time.getMonth() + 3) / 3), //季度
    "S": time.getMilliseconds(), //毫秒
  }

  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length))
    }
  }
  return format
}


/**
 * 获取微信配置
 */
export function getWxConfig(arr) {
  const wx = Vue.wechat
  let href = window.location.href

  get('v1/misc/wechat_config', {
    href: href
  }, function(rsp) {
    let res = rsp.body
    if (res.code == 10000) {
      let wxConfig = res.data
      wx.config({
        debug: false, // 开启调试模式
        appId: wxConfig.appId, // 必填，公众号的唯一标识
        timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
        signature: wxConfig.signature, // 必填，签名
        jsApiList: arr
      })
    }
  })
}

/**
 * 如果页面没有问号(?)，则跳转到正确的url
 * @return {[type]} [description]
 */
export function directRightUrl() {
  let {
    href,
    protocol,
    host,
    search,
    hash
  } = window.location
  const pathname = '/m/' // 解决支付路径问题添加的前缀，替换成你的
  search = search || '?'
  hash = hash || '#/'
  let newHref = `${protocol}//${host}${pathname}${search}${hash}`
  if (newHref !== href) {
    window.location.replace(newHref)
  }
}

/**
 * 数组去重
 */
export function unique(arr) {
  let result = []
  let hash = {}
  for (let i = 0, elem;
    (elem = arr[i]) != null; i++) {
    if (!hash[elem]) {
      result.push(elem)
      hash[elem] = true
    }
  }
  return result
}

/**
 * 记录搜索历史
 */
export function recordSearch(str) {
  let logStr = window.sessionStorage.getItem('searchLog')
  let arr = []

  if (logStr) {
    arr = logStr.split(',')

    if (arr.length >= 10) {
      arr[0] = str
    } else {
      arr.unshift(str)
    }
  } else {
    arr.unshift(str)
  }

  let result = unique(arr).join(',')
  window.sessionStorage.setItem('searchLog', result)
}

export { ESA_IMAGE_PROCESSES, esaImageProcess, esaImageUrl } from './image'

//判断是否为安卓设备
export function isAndroid() {
  var u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    return true;
  }
  return false;
}

//判断是否为微信浏览器
export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  }
  return false;
}

//压入history
export function pushHistory(objs) {
    let state = {
        title: objs.title,
        url: objs.url
    }

    window.history.pushState(state,'', objs.url)
}

/**
 * 微信配送带回调
 */
 export function wxConfigCalBack(arr, callback) {
   const wx = Vue.wechat
   let href = window.location.href

   get('v1/misc/wechat_config', {
     href: href
   }, function(rsp) {
     let res = rsp.body
     if (res.code == 10000) {
       let wxConfig = res.data
       wx.config({
         debug: false, // 开启调试模式
         appId: wxConfig.appId, // 必填，公众号的唯一标识
         timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
         nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
         signature: wxConfig.signature, // 必填，签名
         jsApiList: arr
       })

       wx.ready(() => {
           callback()
       })
     }
   })
 }



// WEBPACK FOOTER //
// ./src/util.js